import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const ShareIcon: FC<IconProps> = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12 10.72C11.4933 10.72 11.04 10.92 10.6933 11.2333L5.94 8.46668C5.97333 8.31334 6 8.16001 6 8.00001C6 7.84001 5.97333 7.68668 5.94 7.53334L10.64 4.79334C11 5.12668 11.4733 5.33334 12 5.33334C13.1067 5.33334 14 4.44001 14 3.33334C14 2.22668 13.1067 1.33334 12 1.33334C10.8933 1.33334 10 2.22668 10 3.33334C10 3.49334 10.0267 3.64668 10.06 3.80001L5.36 6.54001C5 6.20668 4.52667 6.00001 4 6.00001C2.89333 6.00001 2 6.89334 2 8.00001C2 9.10668 2.89333 10 4 10C4.52667 10 5 9.79334 5.36 9.46001L10.1067 12.2333C10.0733 12.3733 10.0533 12.52 10.0533 12.6667C10.0533 13.74 10.9267 14.6133 12 14.6133C13.0733 14.6133 13.9467 13.74 13.9467 12.6667C13.9467 11.5933 13.0733 10.72 12 10.72Z'
      fill={color} />
  </svg>
)

export default ShareIcon
